import { apiBase } from '../../lib/api'

const API_URL = apiBase

function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4)
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/')
  const rawData = window.atob(base64)
  const outputArray = new Uint8Array(rawData.length)
  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i)
  }
  return outputArray
}

export async function subscribeToPush(token, preferences = {}) {
  if (typeof window === 'undefined' || !('serviceWorker' in navigator) || !('PushManager' in window)) {
    throw new Error('Las notificaciones push no están soportadas en este navegador')
  }

  const permission = await Notification.requestPermission()
  if (permission !== 'granted') {
    throw new Error('Permiso de notificaciones denegado')
  }

  const reg = await navigator.serviceWorker.ready
  if (!reg) throw new Error('Service Worker no activo')

  // Fetch server VAPID public key
  const keyRes = await fetch(`${API_URL}/notifications/vapid-public-key`)
  const { publicKey } = await keyRes.json()
  if (!publicKey) throw new Error('No se pudo obtener la clave VAPID pública')

  let subscription = await reg.pushManager.getSubscription()
  if (!subscription) {
    subscription = await reg.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(publicKey)
    })
  }

  // Send subscription to backend
  const subRes = await fetch(`${API_URL}/notifications/subscribe`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
    body: JSON.stringify({ subscription, preferences })
  })

  if (!subRes.ok) {
    const err = await subRes.json().catch(() => ({}))
    throw new Error(err.error || 'Error al guardar suscripción en el servidor')
  }

  return { ok: true }
}

export async function testPush(token) {
  const res = await fetch(`${API_URL}/notifications/test`, {
    method: 'POST',
    headers: { Authorization: `Bearer ${token}` }
  })
  return res.json()
}

export async function getPreferences(token) {
  const res = await fetch(`${API_URL}/notifications/preferences`, {
    headers: { Authorization: `Bearer ${token}` }
  })
  return res.json()
}

export async function updatePreferences(token, preferences) {
  const res = await fetch(`${API_URL}/notifications/preferences`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
    body: JSON.stringify(preferences)
  })
  return res.json()
}
